import React, { Component } from 'react';

import NavBar from '../../components/navigation/NavBar';
import ProgressInfo from '../../components/progressinfo/ProgressInfo';

import { getCurrentResource } from '../../util/tools';
import { 
	DBMANAGER_UPDATE_API_URL, 
	DBMANAGER_GET_UPDATE_INFO_API_URL, DBMANAGER_SET_DB_ACCESS_API_URL, 
	performApiRequest 
} from '../../util/restapi';
import {CLASS_MESSAGE, CLASS_EBOOK_REPORT, CLASS_REQUEST} from '../../util/consts/classes';
import { LIST_CLASSES } from '../../util/model';

import {
	PATCH_RESOLVE_BRAND_PROVIDER_REFS,
	PATCH_NORMALIZE_ORG_CODE_AND_GID,
	PATCH_CLEAR_ORG_DUBLETS,
	PATCH_MAKE_LINK_FROM_PROVIDER_TO_BRAND,
	PATCH_CHANGE_OFFER_PRICE_QUALIFIER,
	PATCH_SET_OFFER_STOP_DATE,
	PATCH_CLEAR_EBOOK_PAYMENT_DOUBLING,
	PATCH_UPDATE_BOOK_YEAR,
	PATCH_BOOK_CLEAR_EMPTY_BRAND,
	PATCH_BOOK_FIX_BR,
	PATCH_REMOVE_BREAKED_IMAGES,
	PATCH_STATUS_MERCHANT_TERMINAL,
	PATCH_SET_TERMINAL_PROVIDER,
	PATCH_UPDATE_EMPTY_OWNERS,
} from "../../util/consts/common";

const FORM_STATE_GET_DATA = 'gd';
const FORM_STATE_WAITING = 'w';
const FORM_STATE_RUNNING = 'r';

const TAB_COMMON = 'common';
const TAB_OBJECTS = 'objects';
const TAB_CARDS = 'cards';
const TAB_LINKS = 'links';
const TAB_FILES = 'files';
const TAB_WORDS = 'words';

class DbManagerPage extends Component {
	
	listPatchInfo = [];
	
	constructor(props) {
		super(props);
		this.resource = getCurrentResource().pages.admin.DbManagerPage;
		this.state = {
			dirtyCount: 0,
			activeTab: TAB_COMMON,
			formState: FORM_STATE_GET_DATA,
			startTaskResponse: null,
			dbAccessMode: '...'
		};
		
		this.patchId = '';
		this.resolveReference = false;
		this.deleteUnusedFiles = false;
		this.reloadCache = false;
		this.clearUnresolvedTerminals = false;
		this.clearUnresolvedReportItems = false;
		this.listObjectClasses = [];
		this.downloadImages = false;
		this.listCardClasses = [];
		this.listLinkClasses = [];
		this.listFileLinkClasses = [];
		this.listWordClasses = [];
		
		for(let cls of LIST_CLASSES) {
			this.listObjectClasses.push( {checked: false, class: cls} );
			this.listCardClasses.push( {checked: false, class: cls} );
			if( cls.hasLinks ) {
				this.listLinkClasses.push( {checked: false, class: cls} );
			}
			if( cls.hasFileLinks ) {
				this.listFileLinkClasses.push( {checked: false, class: cls} );
			}
			if( cls.hasWords ) {
				this.listWordClasses.push( {checked: false, class: cls} );
			}
		}
	}
	componentDidMount = async () => {
		document.title = 'BOM. Налаштування БД';
		const request = {
			taskId: 'task'
		};
		let response = await performApiRequest( DBMANAGER_GET_UPDATE_INFO_API_URL, request );
		if( response.success ) {
			this.listPatchInfo = response.data.listPatchInfo;
			this.setState({dbAccessMode: response.data.dbAccessMode})
		} else {
			this.props.app.showResponse( response );
		}
	}
	setDbAccessMode = async (mode) => {
		const request = {
			dbAccess: mode
		};
		let response = await performApiRequest( DBMANAGER_SET_DB_ACCESS_API_URL, request );
		if( ! response.success ) {
			this.props.app.showResponse( response );
		} else {
			this.setState({dbAccessMode: mode})
		}
	}

	setActiveTab = (tabId) => {
		this.setState({activeTab: tabId});
	}
		
	handleValueChange = (e) => {
		const { name, value } = e.target;
		if( name == 'patch' )
			this.patchId = value;
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleSyncKnrFromDateValueChange = e => {
		var value = e.target.valueAsNumber;
		if( isNaN(value) )
			value = null;
		this.task.syncKnrFromDate = value;
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	};
	handleSyncKnrCheckBoxClick = (e) => {
		var checked = e.target.checked;
		this.task.syncKnr = checked;
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleCommonCheckBoxClick = (e) => {
		const { name, checked } = e.target;
		if( name == 'cbResolveReference' )
			this.resolveReference = checked;
		if( name == 'cbDeleteUnusedFiles' )
			this.deleteUnusedFiles = checked;
		if( name == 'cbReloadCache' )
			this.reloadCache = checked;
		if( name == 'cbClearUnresolvedTerminals' )
			this.clearUnresolvedTerminals = checked;
		if( name == 'cbClearUnresolvedReportItems' )
			this.clearUnresolvedReportItems = checked;
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleObjectCheckBoxClick = (e) => {
		const { name, checked } = e.target;
		for(let c of this.listObjectClasses) {
			if( c.class.id == name ) {
				c.checked = checked;
				break;
			}
		}
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleDownloadImagesCheckBoxClick = (e) => {
		this.downloadImages = e.target.checked;
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleCardCheckBoxClick = (e) => {
		const { name, checked } = e.target;
		for(let c of this.listCardClasses) {
			if( c.class.id == name ) {
				c.checked = checked;
				break;
			}
		}
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleLinkCheckBoxClick = (e) => {
		const { name, checked } = e.target;
		for(let c of this.listLinkClasses) {
			if( c.class.id == name ) {
				c.checked = checked;
				break;
			}
		}
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleFileLinkCheckBoxClick = (e) => {
		const { name, checked } = e.target;
		for(let c of this.listFileLinkClasses) {
			if( c.class.id == name ) {
				c.checked = checked;
				break;
			}
		}
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleWordCheckBoxClick = (e) => {
		const { name, checked } = e.target;
		for(let c of this.listWordClasses) {
			if( c.class.id == name ) {
				c.checked = checked;
				break;
			}
		}
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	
	performTask = async () => {
		let task = {
			patchId: this.patchId,
			resolveReference: this.resolveReference,
			deleteUnusedFiles: this.deleteUnusedFiles,
			reloadCache: this.reloadCache,
			clearUnresolvedTerminals: this.clearUnresolvedTerminals,
			clearUnresolvedReportItems: this.clearUnresolvedReportItems,
			listObjectClass: [],
			downloadImages: this.downloadImages,
			listCardClass: [],
			listLinkClass: [],
			listFileLinkClass: [],
			listWordClass: []
		}
		this.patchId = '';
		this.resolveReference = false;
		this.deleteUnusedFiles = false;
		this.reloadCache = false;
		this.clearUnresolvedTerminals = false;
		this.clearUnresolvedReportItems = false;
		for(let c of this.listObjectClasses) {
			if( c.checked )
				task.listObjectClass.push( c.class.id );
			c.checked = false;
		}
		this.downloadImages = false;
		for(let c of this.listCardClasses) {
			if( c.checked )
				task.listCardClass.push( c.class.id );
			c.checked = false;
		}
		for(let c of this.listLinkClasses) {
			if( c.checked )
				task.listLinkClass.push( c.class.id );
			c.checked = false;
		}
		for(let c of this.listFileLinkClasses) {
			if( c.checked )
				task.listFileLinkClass.push( c.class.id );
			c.checked = false;
		}
		for(let c of this.listWordClasses) {
			if( c.checked )
				task.listWordClass.push( c.class.id );
			c.checked = false;
		}

		this.setState({formState: FORM_STATE_WAITING});
		let response = await performApiRequest(DBMANAGER_UPDATE_API_URL, task);
		this.setState({formState: FORM_STATE_RUNNING, startTaskResponse: response});
	}
	closeProgressInfo = () => {
		this.setState({dirty: false, formState: FORM_STATE_GET_DATA});
	}
		
	render() {
		let divWaiting = (null);
		let disabled = false;
		if( this.state.formState == FORM_STATE_RUNNING ) {
			disabled = true;
			divWaiting = (
				<div style={{textAlign: 'center', marginTop: '15px', border: '1px solid blue'}}>
					<ProgressInfo visible={true} startTaskResponse={this.state.startTaskResponse}
						title={this.resource.labelPerformingTask} interval={2000}
						close={this.closeProgressInfo}
					/>
				</div>
			)
		}
		if( this.state.formState == FORM_STATE_WAITING ) {
			disabled = true;
			divWaiting = (
				<div style={{textAlign: 'center', marginTop: '15px'}}>
					{this.resource.labelWait}
				</div>
			)
		}
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<div style={localStyles.divMainStyle}>
					<div style={{marginBottom: '15px'}}>
						{this.resource.title}
					</div>
					<Tabs holder={this} />
					<div style={{padding: '10px', background: '#f8f8f8', textAlign: 'left'}}>
						<TabBody holder={this} disabled={disabled} />
					</div>					
					{divWaiting}
					<div style={{marginTop: '10px', textAlign: 'right'}}>
						<button type='button' onClick={this.performTask} disabled={disabled}>{this.resource.buttonPerform}</button>
					</div>
				</div>
			</React.Fragment>
		)
	}
	
}

function Tabs(props) {
	var holder=props.holder;
	var res = holder.resource;
	return (
		<div style={{display: 'flex', background: 'lightgray', padding: '10px 10px 0 10px'}}>
			<Tab holder={holder} id={TAB_COMMON} title={res.tabCommon} />
			<Tab holder={holder} id={TAB_OBJECTS} title={res.tabObjects} />
			<Tab holder={holder} id={TAB_CARDS} title={res.tabCards} />
			<Tab holder={holder} id={TAB_LINKS} title={res.tabLinks} />
			<Tab holder={holder} id={TAB_FILES} title={res.tabFiles} />
			<Tab holder={holder} id={TAB_WORDS} title={res.tabWords} />
		</div>
	);
}

function Tab(props) {
	var tabId = props.id; 
	if( tabId == props.holder.state.activeTab )
		var tabStyle = localStyles.divActiveTab;
	else
		var tabStyle = localStyles.divNotActiveTab;
	return (
		<div style={tabStyle} onClick={ ()=>{props.holder.setActiveTab(tabId)} }>
			{props.title}
		</div>
	);
}

function TabBody(props) {
	var tabId = props.holder.state.activeTab;
	
	if( tabId == TAB_COMMON )
		return ( <TabCommon holder={props.holder} disabled={props.disabled} /> );
	if( tabId == TAB_OBJECTS )
		return ( <TabObjects holder={props.holder} disabled={props.disabled} /> );
	if( tabId == TAB_CARDS )
		return ( <TabCards holder={props.holder} disabled={props.disabled} /> );
	if( tabId == TAB_LINKS )
		return ( <TabLinks holder={props.holder} disabled={props.disabled} /> );
	if( tabId == TAB_FILES )
		return ( <TabFiles holder={props.holder} disabled={props.disabled} /> );
	if( tabId == TAB_WORDS )
		return ( <TabWords holder={props.holder} disabled={props.disabled} /> );
}

function TabCommon(props) {
	let holder = props.holder;
	let res = holder.resource;
	
	/*
	let syncKnrFromDate = task.syncKnrFromDate;
	if( syncKnrFromDate != null ) {
		syncKnrFromDate = new Date( syncKnrFromDate )
		syncKnrFromDate = syncKnrFromDate.toISOString().substring(0,10);
	}
			<div style={{marginTop: '20px'}}>
				<input type='checkbox' checked={task.syncKnr} 
					onChange={holder.handleSyncKnrCheckBoxClick} 
				/> Load data from KNR
				<span style={{marginLeft: '30px'}}>From date</span>
				<input type='date' value={syncKnrFromDate}
					onChange={holder.handleSyncKnrFromDateValueChange}
				/>
			</div>
	*/
	
	
	let listExtraPatchHtml = holder.listPatchInfo.map( (info, index) => {
		return (<option value={info.patchId} title={info.patchTooltip}>{info.patchId}</option>);
	});
	let patchDescription = '';
	for(let pi of holder.listPatchInfo) {
		if( holder.patchId == pi.patchId ) {
			patchDescription = pi.patchDescription;
		}
	}	
	return (
		<div>
			<div style={{display: 'flex'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid blue', width: 'calc(50% - 42px)'}}>
					<div>
						<input type='checkbox' checked={holder.resolveReference}
							name='cbResolveReference' 
							onChange={holder.handleCommonCheckBoxClick} 
						/> {res.cbResolveReferences}
					</div>
					<div style={{marginTop: '5px'}}>
						<input type='checkbox' checked={holder.deleteUnusedFiles}
							name='cbDeleteUnusedFiles' 
							onChange={holder.handleCommonCheckBoxClick} 
						/> {res.cbDeleteNotUsedFiles}
					</div>
					<div style={{marginTop: '5px'}}>
						<input type='checkbox' checked={holder.reloadCache}
							name='cbReloadCache' 
							onChange={holder.handleCommonCheckBoxClick} 
						/> Перевантажити буферизовані дані (кеш)
					</div>
					<div style={{marginTop: '10px'}}>
						<div>Вилучити об'єкти з "висячими" посиланнями</div>
						<div style={{marginLeft: '10px'}}>
							<div style={{marginTop: '5px'}}>
								<input type='checkbox' checked={holder.clearUnresolvedTerminals} 
									name='cbClearUnresolvedTerminals' 
									onChange={holder.handleCommonCheckBoxClick} 
								/> Термінали 
							</div>
							<div style={{marginTop: '5px'}}>
								<input type='checkbox' checked={holder.clearUnresolvedReportItems} 
									name='cbClearUnresolvedReportItems' 
									onChange={holder.handleCommonCheckBoxClick} 
								/> Елементи звітів 
							</div>
						</div>
					</div>
				</div>
				<div style={{margin: '10px', padding: '10px', border: '1px solid blue', width: 'calc(50% - 42px)'}}>
					<div>
						{res.labelPatch}:&nbsp;
						<select name='patch' value={holder.patchId} disabled={props.disabled} onChange={holder.handleValueChange}>
							<option value="">&nbsp;</option>
							<option value={PATCH_RESOLVE_BRAND_PROVIDER_REFS}>{PATCH_RESOLVE_BRAND_PROVIDER_REFS}</option>
							<option value={PATCH_NORMALIZE_ORG_CODE_AND_GID}>{PATCH_NORMALIZE_ORG_CODE_AND_GID}</option>
							<option value={PATCH_CLEAR_ORG_DUBLETS}>{PATCH_CLEAR_ORG_DUBLETS}</option>
							<option value={PATCH_MAKE_LINK_FROM_PROVIDER_TO_BRAND}>{PATCH_MAKE_LINK_FROM_PROVIDER_TO_BRAND}</option>
							<option value={PATCH_CHANGE_OFFER_PRICE_QUALIFIER}>{PATCH_CHANGE_OFFER_PRICE_QUALIFIER}</option>
							<option value={PATCH_SET_OFFER_STOP_DATE}>{PATCH_SET_OFFER_STOP_DATE}</option>
							<option value={PATCH_CLEAR_EBOOK_PAYMENT_DOUBLING}>{PATCH_CLEAR_EBOOK_PAYMENT_DOUBLING}</option>
							<option value={PATCH_UPDATE_BOOK_YEAR}>{PATCH_UPDATE_BOOK_YEAR}</option>
							<option value={PATCH_BOOK_CLEAR_EMPTY_BRAND}>{PATCH_BOOK_CLEAR_EMPTY_BRAND}</option>
							<option value={PATCH_BOOK_FIX_BR}>{PATCH_BOOK_FIX_BR}</option>
							<option value={PATCH_REMOVE_BREAKED_IMAGES}>{PATCH_REMOVE_BREAKED_IMAGES}</option>
							<option value={PATCH_STATUS_MERCHANT_TERMINAL}>{PATCH_STATUS_MERCHANT_TERMINAL}</option>
							<option value={PATCH_SET_TERMINAL_PROVIDER}>{PATCH_SET_TERMINAL_PROVIDER}</option>
							<option value={PATCH_UPDATE_EMPTY_OWNERS}>{PATCH_UPDATE_EMPTY_OWNERS}</option>
							{listExtraPatchHtml}
						</select>
					</div>
					<div style={{marginTop: '15px'}}>
						{patchDescription}
					</div>
				</div>
			</div>
			<div style={{margin: '10px', padding: '10px', border: '1px solid blue', width: 'calc(100% - 42px)'}}>
				Database access level: 
				<span style={{marginLeft: '15px', marginRight: '30px', color: 'blue'}}>{holder.state.dbAccessMode}</span>
				<button type='button' style={{marginLeft: '15px'}}
					onClick={()=> {holder.setDbAccessMode('readWrite')}}
				>
					Read/Write
				</button>
				<button type='button' style={{marginLeft: '15px'}}
					onClick={()=> {holder.setDbAccessMode('readOnly')}}
				>
					Read Only
				</button>
				<button type='button' style={{marginLeft: '15px'}}
					onClick={()=> {holder.setDbAccessMode('none')}}
				>
					Locked
				</button>
			</div>
		</div>
	);
}

function TabObjects(props) {
	let holder = props.holder;
	let res = props.holder.resource;
	let listCheckBoxHtml = props.holder.listObjectClasses.map( (c,index) => {
		if( c.class.id == CLASS_MESSAGE || c.class.id == CLASS_EBOOK_REPORT || c.class.id == CLASS_REQUEST) {
			return null;
		}
		return (
			<div key={index}>
				<input 
					type='checkbox' name={c.class.id} checked={c.checked} 
					onChange={props.holder.handleObjectCheckBoxClick} 
				/> {c.class.id}
			</div>
		);
	} );
	return (
		<div>
			<div style={{textAlign: 'center', margin: '10px'}}>
				{res.labelRebuildObjects}
			</div>
			<div style={{display: 'flex'}}>
				<div>
					{listCheckBoxHtml}
				</div>
				{/*
				<div style={{marginLeft: '100px'}}>
					<input 
						type='checkbox' name={'downloadImages'} checked={holder.downloadImages} 
						onChange={props.holder.handleDownloadImagesCheckBoxClick} 
					/> {res.cbDownloadImages}
				</div>
				*/}
			</div>
		</div>
	);
}

function TabCards(props) {
	let res = props.holder.resource;
	let listCheckBoxHtml = props.holder.listCardClasses.map( (c,index) => {
		return (
			<div key={index}>
				<input 
					type='checkbox' name={c.class.id} checked={c.checked} 
					onChange={props.holder.handleCardCheckBoxClick} 
				/> {c.class.id}
			</div>
		);
	} );
	return (
		<div>
			<div style={{textAlign: 'center', margin: '10px'}}>
				{res.labelRebuildCards}
			</div>
			{listCheckBoxHtml}
		</div>
	);
}

function TabLinks(props) {
	let res = props.holder.resource;
	let listCheckBoxHtml = props.holder.listLinkClasses.map( (c,index) => {
		return (
			<div key={index}>
				<input 
					type='checkbox' name={c.class.id} checked={c.checked} 
					onChange={props.holder.handleLinkCheckBoxClick} 
				/> {c.class.id}
			</div>
		);
	} );
	return (
		<div>
			<div style={{textAlign: 'center', margin: '10px'}}>
				{res.labelRebuildLinks}
			</div>
			{listCheckBoxHtml}
		</div>
	);
}

function TabFiles(props) {
	let res = props.holder.resource;
	let listCheckBoxHtml = props.holder.listFileLinkClasses.map( (c,index) => {
		return (
			<div key={index}>
				<input 
					type='checkbox' name={c.class.id} checked={c.checked} 
					onChange={props.holder.handleFileLinkCheckBoxClick} 
				/> {c.class.id}
			</div>
		);
	} );
	return (
		<div>
			<div style={{textAlign: 'center', margin: '10px'}}>
				{res.labelRebuildFiles}
			</div>
			{listCheckBoxHtml}
		</div>
	);
}

function TabWords(props) {
	let res = props.holder.resource;
	let listCheckBoxHtml = props.holder.listWordClasses.map( (c,index) => {
		return (
			<div key={index}>
				<input 
					type='checkbox' name={c.class.id} checked={c.checked} 
					onChange={props.holder.handleWordCheckBoxClick} 
				/> {c.class.id}
			</div>
		);
	} );
	return (
		<div>
			<div style={{textAlign: 'center', margin: '10px'}}>
				{res.labelRebuildWords}
			</div>
			{listCheckBoxHtml}
		</div>
	);
}

const localStyles = {
	divMainStyle: {
		width: '1000px', 
		border: '1px solid blue', 
		marginLeft: 'auto', 
		marginRight: 'auto',
		marginTop: '20px',
		marginBottom: '20px',
		padding: '10px'
	},
	divActiveTab: {
		margin: '10px 0px 0 0px', /* top | right | bottom | left */
		padding: '5px 10px 5px 10px',
		fontWeight: 'bold',
		borderLeft: '1px solid grey',
		borderRight: '1px solid grey',
		borderTop: '1px solid grey',
		borderRadius: '20px 0px 0 0',
		background: '#f8f8f8',
		cursor: 'pointer'
	},	
	divNotActiveTab: {
		margin: '10px 0px 0 0px',
		padding: '5px 10px 5px 10px',
		borderLeft: '1px solid grey',
		borderRight: '1px solid grey',
		borderTop: '1px solid grey',
		borderRadius: '20px 0px 0 0',
		background: 'lightgray',
		cursor: 'pointer'
	},	
};

export default DbManagerPage;
